export const NUMBER_OF_BRANDS_PER_PAGE = 15

export const MAX_CATEGORIES_FOR_FILTER = 5
